import React from 'react';
import styles from './css/TargetYearChangeModal.module.css';
import { Button } from '@/components/Buttons';

interface TargetYearChangeModalProps {
  isOpen: boolean;
  message: string;
  onClose: () => void;
}

const TargetYearChangeModal: React.FC<TargetYearChangeModalProps> = ({
  isOpen,
  message,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.iconContainer}>
          <svg 
            className={styles.warningIcon} 
            fill="currentColor" 
            viewBox="0 0 20 20"
          >
            <path 
              fillRule="evenodd" 
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" 
              clipRule="evenodd" 
            />
          </svg>
        </div>
        
        <h2 className={styles.title}>שנת היעד שונתה</h2>
        <p className={styles.message}>{message}</p>
        
        <div className={styles.recommendations}>
          <h3 className={styles.subTitle}>מומלץ לבצע:</h3>
          <ul className={styles.list}>
            <li>לבדוק את האלטרנטיבות הקיימות</li>
            <li>לעדכן אלטרנטיבות עם סימון צהוב (דורשות עדכון)</li>
            <li>לוודא שהתחזיות מתאימות לשנת היעד החדשה</li>
          </ul>
        </div>

        <div className={styles.buttonContainer}>
          <Button 
            data-testid="modal-close-btn" 
            icon='no' 
            id='close' 
            popupstyle="gray" 
            onClick={onClose} 
            text="הבנתי"
          />
        </div>
      </div>
    </div>
  );
};

export default TargetYearChangeModal;
